import type { AccountSeatOverview } from "@/domain/model/AccountSeatOverview";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";

export class GetAccountSeats {
  constructor(private readonly service: AccountManagementService) {}

  execute(signal?: AbortSignal): Promise<AccountSeatOverview> {
    return this.service.getAccountSeats(signal);
  }
}
